import { MainNavbar } from "../components/MainNavbar";
import { Outlet } from "react-router-dom";
import React from "react";
import { Box } from "@mui/material";

/**
 * The layout for when no user is logged in
 *
 */

export function BaseLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        overflow: "hidden",
        width: "100%",
        paddingTop: 5,
      }}
    >
      <div
        style={{
          display: "flex",
          flex: "1 1 auto",
          overflow: "hidden",
        }}
        data-testid={"main-container"}
      >
        <div style={{ display: "flex", flex: "1 1 auto", overflow: "hidden" }}>
          <div style={{ flex: "1 1 auto", overflow: "auto" }}>
            <MainNavbar />
            <Outlet />
          </div>
        </div>
      </div>
    </Box>
  );
}
